/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * The onboarding milestone this status refers to.
 */
export type OnboardingStep = (typeof OnboardingStep)[keyof typeof OnboardingStep];

export const OnboardingStep = {
  CREATE_ORGANIZATION: "CREATE_ORGANIZATION",
  SETUP_PLATFORM: "SETUP_PLATFORM",
  CREATE_CIRCUIT: "CREATE_CIRCUIT",
  ADD_OPERATOR: "ADD_OPERATOR",
  CREATE_EVENT: "CREATE_EVENT",
} as const;
